import { setClassValidatorMessages } from 'class-validator-multi-lang'
import ko from '@/plugins/class-validator/ko.json'
import ja from 'class-validator-multi-lang/i18n/ja.json'
import en from 'class-validator-multi-lang/i18n/en.json'
import i18n from '@/user/plugins/i18n'
import { watch } from 'vue'
import { Locale } from '@/models/locale'

const messages = {
  ko,
  ja,
  en,
}

export default {
  install() {
    watch(
      () => i18n.global.locale,
      () => {
        setClassValidatorMessages(messages[i18n.global.locale])
      }
    )

    setClassValidatorMessages(messages[Locale.getLanguage()])
  },
}
